// extracted by mini-css-extract-plugin
module.exports = {"root":"SelectSecondary_root__2H7SK","vLegacy":"SelectSecondary_vLegacy__32hAL","error":"SelectSecondary_error__1lHO6","disabled":"SelectSecondary_disabled__3er5R"};